/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MonitorType } from './monitorType';


export interface MonitorDefinition { 
    monitor_type?: MonitorType;
    version?: string;
    /**
     * Monitoring URL template or script.
     */
    monitor_content?: string;
    monitor_folder?: number;
    monitor_name_template?: string;
    check_interval_sec?: number;
    threshold_failure_count?: number;
}
export namespace MonitorDefinition {
}


